import React, { useCallback, useEffect, useState } from 'react'
import ImageWithBasePath from '../../../../core/common/imageWithBasePath';
import { svgIcons } from '../../../../style/fonts/SvgIcons';
import Table from "../../../../core/common/dataTable/index";
import { Col, Nav, Row, Tab } from "react-bootstrap";
import { Link, useParams } from 'react-router-dom';
import DateRangePicker from 'react-bootstrap-daterangepicker';
import { ClientData } from './ClientData';
import ClientVisitSidebar from './ClientVisitsidebar/ClientVisitSidebar';
import CustomSelect from '../../../../core/common/selectPirority/SelectPirority';
import ModalComponent from '../../../../core/common/modal/ModalComponent';
import { useGetAllClientVisitDetailsQuery } from '../../../../services/EndPointsApis';
import { debounce } from 'lodash';
import { useTableSelection } from '../../../../core/hooks/useTableSelection';
import TableHeading from '../../../../core/common/tableHeading/TableHeading';
import TextField from '../../../../core/common/textFields/TextField';
import NoRecordFound from '../../../../core/common/noRecord/NoRecordFound';
import TableLoading from '../../../../core/common/loadingComponent/TableLoading';
import Pagination from '../../../../core/common/pagination/Pagination';
import { useSelector } from 'react-redux';
import { usePermission } from '../../../../core/hooks/PermissionHook';
import { constantsPermission } from '../../../../Config/Constants';
import DateComp from '../../../../core/common/dateComponent/DateComp';


const ClientVisit = ({ projectLookups, projectId }: any) => {

  //PermissionHook
  const { view: viewClientVisits, edit: editClientVisits, create: createClientVisits } = usePermission(constantsPermission?.moduleId?.clientVisit);


  const [selectedRowId, setSelectedRowId] = useState<any[]>([]);
  const data = ClientData;
  const [activityTogglePopup, setActivityTogglePopup] = useState(false);
  const [isEditing, setIsEditing] = useState(false);
  const [isViewOnly, setIsViewOnly] = useState(false);
  const [showfilterModal, setShowfilterModal] = useState(false);
  const [viewOnly, setViewOnly] = useState(false)


  const [pageNumber, setPageNumber] = useState(1)
  const [pageSize, setPageSize] = useState(15);
  const [searchStr, setSearchStr] = useState(''); // debounce search
  const [sortBy, setSortBy] = useState("createDT");
  const [sortOrder, setSortOrder] = useState("desc");
  const [sortedColumn, setSortedColumn] = useState("createDT");
  const [immediateSearchStr, setImmediateSearchStr] = useState('')

  const { data: allClientVisits, isLoading: allClientVisitsIsLoading, refetch } = useGetAllClientVisitDetailsQuery({
    pageNumber: pageNumber,
    pageSize: pageSize,
    searchStr: searchStr || '',
    sortBy: sortBy,
    sortOrder: sortOrder,
    projectId: projectId,
  });
  const handlePageSizeChange = (selectedOption: any) => {
    setPageSize(selectedOption.value);
    setPageNumber(1); // Reset page number to 1
  };
  // pagination
  const handlePageClick = (e: any) => {
    setPageNumber(e.selected + 1);
  };
  //per page record
  const handlePageRecords = (e: any) => {
    setPageNumber(1); // Reset the page to 1
  };
  const handleSort = (property: string) => {
    setSortBy(property);
    if (sortedColumn === property) {
      setSortOrder(prevSortOrder => (prevSortOrder === "asc" ? "desc" : "asc"));
    } else {
      setSortedColumn(property);
      setSortOrder("asc");
    }
    // Perform additional sorting logic...
  };
  const handleSearchChange = (e: any) => {
    const { value } = e.target;
    setImmediateSearchStr(value);
    delayedSearch(value);
  };

  const delayedSearch = useCallback(
    debounce((searchValue) => {
      setSearchStr(searchValue);
    }, 500),
    []
  );
  useEffect(() => {
    if (searchStr === "" ||
      sortOrder === "" ||
      sortBy === "") {
      refetch();
    }
  }, [searchStr, sortOrder, sortBy]);

  const {
    isTableHeadChecked,
    selectedIndividualCheckboxId,
    selectedItemData: clientVisitsData,
    handleTableHeadChange,
    handleCheckItem,
    handleRowClick,
    handleRowDoubleClick,
    setSelectedIndividualCheckboxId,
    setIsTableHeadChecked,
    setSelectedItemData
  } = useTableSelection(allClientVisits?.result?.data || [], 'clientVisitId');

  const isAnyCheckboxChecked = selectedIndividualCheckboxId.length > 0;
  const isMoreThanOneChecked = selectedIndividualCheckboxId.length > 1;

  const handleDoubleClick = (items: any) => {
    handleRowDoubleClick(items);
    setViewOnly(true);
    if (!isAnyCheckboxChecked) {
      handleViewClientVisit();
    }
  };


  const handleRowClicked = (data: any) => {
    handleRowClick(data);
  }


  const handlefiltermodel = () => {
    setShowfilterModal(true);

    const dropdownToggle = document.getElementById('dropdownMenuClickableinsise');
    if (dropdownToggle) {
      dropdownToggle.click();
    }
  }

  const handleAddClientVisit = () => {
    setActivityTogglePopup(true);
    setIsEditing(false);
    setIsViewOnly(false)

  };
  const handleEditClientVisit = () => {
    setActivityTogglePopup(true);
    setIsEditing(true)
    setIsViewOnly(false)

  };
  const handleViewClientVisit = () => {
    setActivityTogglePopup(true);
    setIsEditing(false)
    setIsViewOnly(true)
  };

  const closeSidebar = () => {
    setActivityTogglePopup(false);
    setSelectedIndividualCheckboxId([])

  };


  const handleClose = () => {
    setShowfilterModal(false)
    setSelectedIndividualCheckboxId([])
  };
  const options1 = [
    { value: 'All Users', label: 'All Users' },
    { value: "Active Users", label: "Active Users" },
    { value: "Inactive Users", label: "Inactive Users" },
    { value: "Active Organization Admin", label: "Active Organization Admin" },
  ];


  return (
    <>
      <ModalComponent
        modalTitle='Saving Current Filters'
        isVisible={showfilterModal}
        cancelButton="Cancel"
        onClose={handleClose}
        saveButton='Save'
        className="p-2"

      >
        <>
          <div className="col-md-12">
            <label className="col-form-label">
              Filter Name<span className="text-danger"> *</span>
            </label>
            <input type="text" className="form-control" />
          </div>
        </>

      </ModalComponent>
      <ClientVisitSidebar
        activityTogglePopup={activityTogglePopup}
        closeSidebar={closeSidebar}
        isEditing={isEditing}
        isViewOnly={isViewOnly}
        clientVisitsData={clientVisitsData}
        projectLookups={projectLookups}
        refetch={refetch}
        setSelectedIndividualCheckboxId={setSelectedIndividualCheckboxId}
        setIsTableHeadChecked={setIsTableHeadChecked}
        setSelectedItemData={setSelectedItemData}
      />
      <div className='row'>
        <div className='col-md-12'>
          <div className="card main-card">
            <div className="card-body">
              {/* <h4 className='color-red'>
                C968749
              </h4>
              <p>
                Emma Lienau & James Liennau
              </p> */}
              {/* Search */}
              <div className="search-section">
                <div className="row">
                  <div className="col-md-8 col-sm-12 d-flex gap-3  align-items-center mb-2">
                    <div className="filter-section filter-flex w-100 ">
                      <div className="filter-list">
                        <ul>
                          <li>
                            <div className=" icon-form">
                              <span className="form-icon">
                                <i className="ti ti-search" />
                              </span>
                              <input
                                type="text"
                                className="form-control"
                                placeholder="Search"
                                value={immediateSearchStr}
                                onChange={handleSearchChange}
                              />
                            </div>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-4 col-sm-8 mb-2">
                    <div className='d-flex justify-content-end gap-3 '>
                      {editClientVisits &&
                        <button className="btn btn-transparent border-0 p-0" disabled={!isAnyCheckboxChecked || isMoreThanOneChecked} onClick={handleEditClientVisit}><span className='me-2'>{svgIcons.updateIcon}</span>Edit</button>
                      }
                      {createClientVisits &&
                        <button className="btn btn-primary" disabled={isAnyCheckboxChecked || isMoreThanOneChecked} onClick={handleAddClientVisit}>+ New Client Visit </button>
                      }
                    </div>
                  </div>
                </div>
              </div>
              {/* Projects List */}
              <div className="row">
                <div className="col-md-12">
                  <div className="table-responsive custom-tableCV mt-2">
                    <table className="table datanew dataTable no-footer table-hoverr">
                      <thead>
                        <tr>
                          <th>
                            <input
                              type="checkbox"
                              className='form-check-input cursor-pointer'
                              checked={isTableHeadChecked}
                              onChange={handleTableHeadChange}
                            />
                          </th>
                          <TableHeading
                            label='VISIT ID'
                            sortedColumn='visitId'
                            columnId='visitId'
                            sortOrder='desc'
                            key='userId'
                            handleSort={handleSort}
                          />
                          <TableHeading
                            label='TYPE'
                            sortedColumn='type'
                            columnId='type'
                            sortOrder='desc'
                            handleSort={handleSort}
                          />
                          <TableHeading
                            label='VISIT DATE'
                            sortedColumn='visitDate'
                            columnId='visitDate'
                            sortOrder='desc'
                            handleSort={handleSort}
                          />
                          <TableHeading
                            label='OUTCOMES'
                            sortedColumn='outcomes'
                            columnId='outcomes'
                            sortOrder='desc'
                            handleSort={handleSort}
                          />
                        </tr>
                      </thead>
                      <tbody>
                        {!allClientVisitsIsLoading && <>
                          {allClientVisits?.result?.data?.length > 0 ? (
                            <>
                              {allClientVisits?.result?.data?.map((data: any, index: any) => (
                                <tr key={data?.clientVisitId} onClick={() => handleRowClicked(data)} onDoubleClick={() => handleDoubleClick(data)}
                                  className={selectedIndividualCheckboxId.includes(data?.clientVisitId) ? 'selected-row' : ''}>
                                  <td>
                                    <TextField
                                      type="checkbox"
                                      fieldClass='form-check-input cursor-pointer'
                                      checked={isTableHeadChecked || selectedIndividualCheckboxId.includes(data.clientVisitId)}
                                      onChange={(e) => handleCheckItem(e, data)}
                                    />
                                  </td>
                                  <td>{data?.recordNumber}</td>
                                  <td>{data?.lst_VisitType?.value ? data?.lst_VisitType?.value : ''}</td>
                                  <td><DateComp formattedDate={data?.scheduledDate} /></td>
                                  <td>{data?.lst_OutComeOfVisit?.value ? data?.lst_OutComeOfVisit?.value : ''}</td>
                                </tr>
                              ))}
                            </>
                          ) :
                            (
                              <tr>
                                <td colSpan={20}>
                                  <NoRecordFound />
                                </td>
                              </tr>
                            )}
                        </>}
                        {allClientVisitsIsLoading &&
                          <TableLoading />
                        }
                      </tbody>
                    </table>
                  </div>
                  <Pagination
                    // totalResult={allClientVisits?.result?.value?.result?.totalRecords === 0 ? 0 : ((allClientVisits?.result?.value?.result?.pageNumber - 1) * allClientVisits?.result?.value?.result?.pageSize) + 1}
                    // toResult={allClientVisits?.result?.value?.result?.totalRecords === 0 ? 0 : Math.min(allClientVisits?.result?.value?.result?.pageNumber * allClientVisits?.result?.value?.result?.pageSize, allClientVisits?.result?.value?.result?.totalRecords)}
                    // ofResult={allClientVisits?.result?.value?.result?.totalRecords}
                    onChange={handlePageSizeChange}
                    pageSize={pageSize}
                    onPageChange={handlePageClick}
                    pageCount={allClientVisits?.result?.totalPages || 0}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

    </>
  )
}

export default ClientVisit
